export default "__VITE_ASSET__Cq_qsY$n__"